import { fg } from '@atlassian/jira-feature-gating';

const DevSummaryPanelWivRelayProvider = {
	get(): boolean {
		return fg('gate-dev-summary-fragment-wiv');
	},
};

export default DevSummaryPanelWivRelayProvider;
